import React from "react";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import "../SbtierCSS/SbtierHome.css";
import SubmitQuery from "./SbtierSemiQweryForm";
import useDocumentMeta from "../hooks/useDocumentMeta";

const approachPrinciples = [
  {
    tag: "// ENGINEERING",
    title: "Engineering Excellence",
    text: "Semiconductor innovation is driven by engineering mastery. We invest in our engineers, equip them with the latest tools and technology, and foster an environment that encourages creativity and problem-solving at the highest level.",
  },
  {
    tag: "// AGILITY",
    title: "Agility and Adaptability",
    text: "Being a startup allows us to be agile, adapt to market changes, and capitalize on emerging opportunities with speed and precision. We are not bound by legacy systems or processes, and we leverage this freedom to innovate faster.",
  },
  {
    tag: "// CUSTOMERS",
    title: "Customer-Centric Innovation",
    text: "Our customers are at the core of everything we do. We listen carefully to their challenges and design solutions that exceed their expectations, built on mutual trust and the shared goal of pushing technological boundaries together.",
  },
  {
    tag: "// SUSTAINABILITY",
    title: "Sustainability in Design",
    text: "As stewards of the environment, we are committed to developing energy-efficient, sustainable solutions — from minimizing power consumption in our designs to exploring materials that reduce environmental impact.",
  },
  {
    tag: "// QUALITY",
    title: "Quality Above All",
    text: "Quality is the foundation of our success. Whether it's in our design process, manufacturing, or customer service, we prioritize reliability, consistency, and excellence our customers can trust.",
  },
];

function SbtierHome() {
  useDocumentMeta(
    null,
    "SatyaBalTech Semiconductor (SBTS) designs custom semiconductors, SoCs, and embedded systems for automotive, IoT, and industrial applications. Talk to our engineers."
  );

  return (
    <div className="sbtier-home-container">
      {/* Welcome / Hero Section */}
      <div
        className="sbtier-welcome-section"
        style={{ backgroundImage: 'url("/images/sbsi_background_22.png")' }}
      >
        <div className="hero-overlay" />
        <div className="hero-inner">
          <span className="hero-eyebrow">Semiconductor Engineering</span>
          <Typography variant="h3" component="h3" className="welcome-title">
            Welcome to <span className="highlight">SatyaBalTech Semiconductor</span>
          </Typography>
          <Typography variant="body1" className="welcome-text">
            Pioneering the Future of Semiconductor Technology. At SatyaBalTech semiconductor, we
            are not just building products; we are shaping the future of technology. Our mission
            is clear: to innovate, develop, and deliver cutting-edge semiconductor solutions that
            redefine the technological landscape and drive industries forward.
          </Typography>
          <div className="hero-cta-row">
            <Link to="/contact-us" className="sbtier-btn sbtier-btn-primary">
              Talk to our engineers
            </Link>
            <Link to="/Sbtier-Services" className="sbtier-btn sbtier-btn-secondary">
              View services
            </Link>
          </div>
        </div>
      </div>

      {/* Vision Section */}
      <section className="sbtier-vision-section">
        <div className="vision-content">
          <Typography variant="h3" component="h3">
            Our Vision
          </Typography>
          <Typography variant="body1" className="vision-text">
            We envision a world where semiconductor technology seamlessly integrates into every
            aspect of life, powering advancements in artificial intelligence, IoT, automotive,
            telecommunications, healthcare, and more. Our goal is to become a key enabler of this
            revolution, crafting solutions that meet the increasing demands for higher
            performance, efficiency, and scalability.
          </Typography>
        </div>
        <div className="vision-image">
          <img src="images/home_vision.webp" alt="Our Vision" />
        </div>
      </section>

      {/* Approach Section */}
      <section className="sbtier-approach-section">
        <Typography variant="h3" component="h3">
          Our Approach
        </Typography>
        <Typography variant="body1" className="approach-text">
          In a rapidly changing and competitive semiconductor landscape, we adhere to several
          guiding principles that will define our approach as we grow:
        </Typography>
        <div className="approach-grid">
          <div className="approach-image">
            <img src="images/home_approach.webp" alt="Our Approach" />
          </div>
          <div className="approach-cards">
            {approachPrinciples.map((principle) => (
              <div className="approach-card" key={principle.title}>
                <span className="approach-card-tag">{principle.tag}</span>
                <h4>{principle.title}</h4>
                <p>{principle.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Embracing Challenges */}
      <section className="sbtier-embracing-section">
        <div className="embracing-content">
          <Typography variant="h3" component="h3">
            Embracing Challenges
          </Typography>
          <Typography variant="body1" className="embracing-text">
            We know that building a semiconductor company from the ground up is not easy. The
            semiconductor industry is fiercely competitive, and the challenges are numerous —
            ranging from maintaining cutting-edge process technologies to scaling production to
            meet the global demand. Yet, we thrive in these challenges. With each obstacle comes
            an opportunity for us to innovate and find better, smarter solutions.
          </Typography>
        </div>
        <div className="embracing-image">
          <img src="images/home-embracing.webp" alt="Embracing Challenges" />
        </div>
      </section>

      {/* Commitment Section */}
      <section className="sbtier-commitment-section">
        <div className="commitment-image">
          <img src="images/home.webp" alt="Our Commitment" />
        </div>
        <div className="commitment-content">
          <Typography variant="h3" component="h3">
            Our Commitment to the Future
          </Typography>
          <Typography variant="body1" className="commitment-text">
            At SatyaBalTech Semiconductor, we believe the future is what we make of it. The
            technologies we develop today will drive the innovations of tomorrow. From AI and
            machine learning to autonomous vehicles and smart cities, the next wave of industrial
            and societal transformation will be powered by the semiconductor technologies we
            create. We look forward to building strong partnerships, developing world-class
            technologies, and making a lasting impact on the semiconductor industry.
          </Typography>
        </div>
      </section>

      {/* Submit Query */}
      <section className="sbtier-query-section">
        <SubmitQuery />
      </section>
    </div>
  );
}

export default SbtierHome;
